import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IBetData } from "../../../core/src/server/data/IBetData";

export default class BalanceDataParser implements IBaseDataParser<IBetData> {

    // this is for Fantasma prototype server
    check(data: any): boolean {
        return false;
    }
    parse(data: any): IBetData | IBetData[] {
        let result: IBetData = {}
        return result;
    }
}
